import styled from "styled-components";
import theme from "../theme";

interface Props {
  color?: "default" | "alternate";
  large?: boolean;
}

const Button = styled.button<Props>`
  padding: ${theme.unit * 0.5}px ${theme.unit}px;
  font-size: ${theme.fonts.small.fontSize};
  border-radius: 20px 0px;
  background: ${(props) =>
    props.color === "alternate" ? theme.colors.orange : theme.colors.blue};
  color: ${theme.colors.white};
  cursor: pointer;
  border: 0;

  ${({ large }) =>
    large &&
    `
    font-size: ${theme.fonts.big.fontSize};
    width: 100%;
    padding: ${theme.unit}px;
  `}

  @media (min-width: ${theme.mediaQueries.tablet}px) {
    padding: ${theme.unit}px ${theme.unit * 2}px;
    font-size: ${theme.fonts.tablet.small.fontSize};
  }
`;

export default Button;
